const streetSuffixMap = {
  STREET: "ST",
  ROAD: "RD",
  AVENUE: "AVE",
  BOULEVARD: "BLVD",
  COURT: "CT",
  CIRCLE: "CIR",
  DRIVE: "DR",
  LANE: "LN",
  TERRACE: "TER",
  PLACE: "PL",
  TRAIL: "TRL",
  PARKWAY: "PKWY",
  HIGHWAY: "HWY",
  EXPRESSWAY: "EXPY",
  FREEWAY: "FWY",
  TURNPIKE: "TPKE",
  ALLEY: "ALY",
  CROSSING: "XING",
  EXTENSION: "EXT",
  JUNCTION: "JCT",
  LOOP: "LOOP",
  MANOR: "MNR",
  POINT: "PT",
  RIDGE: "RDG",
  SQUARE: "SQ",
  WALK: "WALK",
  WAY: "WAY",
};

export function normalizeStreetName(streetName) {
  if (!streetName || typeof streetName !== "string") return "";

  const parts = streetName.toUpperCase().split(" ");
  const lastWord = parts[parts.length - 1];
  if (
    streetSuffixMap[lastWord] ||
    Object.values(streetSuffixMap).includes(lastWord)
  ) {
    parts.pop(); // remove last word (suffix)
    return parts.join(" ");
  }
  return streetName;
}

export function stripUnitFromStreet(streetName) {
  if (!streetName || typeof streetName !== "string") return "";

  return streetName
    .replace(
      /\s+(?:#\s*[A-Z0-9-]+|APT\.?\s+[A-Z0-9-]+|APARTMENT\s+[A-Z0-9-]+|UNIT\s+[A-Z0-9-]+|STE\.?\s+[A-Z0-9-]+|SUITE\s+[A-Z0-9-]+|FLOOR\s+[A-Z0-9-]+|FL\.?\s+[A-Z0-9-]+)\s*$/i,
      "",
    )
    .trim();
}

export function buildRealEstateSearchQuery(address) {
  if (!address || typeof address !== "string") return "";

  const parts = address
    .split(",")
    .map((part) => part.trim())
    .filter(Boolean);

  const streetPart = stripUnitFromStreet(parts[0] || "");
  const cityPart = parts[1] || "";

  return [streetPart, cityPart]
    .filter(Boolean)
    .join(" ")
    .replace(/\s+/g, " ")
    .trim()
    .toUpperCase();
}

/**
 * Enhanced normalization that creates multiple variations
 */
export function createStreetNameVariations(streetName) {
  if (!streetName || typeof streetName !== "string") return [streetName];

  const variations = [streetName]; // Include original
  const parts = streetName.toUpperCase().split(" ");
  const lastWord = parts[parts.length - 1];

  // If last word is a suffix, create variations
  if (streetSuffixMap[lastWord]) {
    // Add abbreviated version
    const withAbbrev = [...parts.slice(0, -1), streetSuffixMap[lastWord]].join(
      " ",
    );
    variations.push(withAbbrev);
  } else if (Object.values(streetSuffixMap).includes(lastWord)) {
    // Add full version
    const fullSuffix = Object.keys(streetSuffixMap).find(
      (key) => streetSuffixMap[key] === lastWord,
    );
    if (fullSuffix) {
      const withFull = [...parts.slice(0, -1), fullSuffix].join(" ");
      variations.push(withFull);
    }
  }

  // Add version without suffix
  const withoutSuffix = normalizeStreetName(streetName);
  if (withoutSuffix !== streetName) {
    variations.push(withoutSuffix);
  }

  return [...new Set(variations)]; // Remove duplicates
}
